import { getBaseThemeName, getTheme } from "@/features/branding";
import QuestionCircleOutlined from "@ant-design/icons/es/icons/QuestionCircleOutlined";
import { Button } from "antd";
import Link from "next/link";
import { ReactNode } from "react";
const GeocodingHelpButton = ({
  children,
  className,
  isLink = false
}: {
  isLink?: boolean;
  className?: string;
  children?: ReactNode;
}) => {
  const geocodingLink = getBaseThemeName() === "hkma" ? getTheme().meta.config.geocoding.guidelineDocumentUrl : "/geocoding";
  return isLink ? <Link className={className} target="_blank" href={geocodingLink} data-sentry-element="Link" data-sentry-component="GeocodingHelpButton" data-sentry-source-file="GeocodingHelpButton.tsx">
      {children}
    </Link> : <Button type="text" className={`!mx-0 !text-gray-800 no-underline ${className}`} size="small" target="_blank" icon={!isLink && <QuestionCircleOutlined />} href={geocodingLink} data-sentry-element="Button" data-sentry-component="GeocodingHelpButton" data-sentry-source-file="GeocodingHelpButton.tsx">
      {children}
    </Button>;
};
export default GeocodingHelpButton;